import DetailsContainer from './details-container';

export default DetailsContainer;
